import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import MobileBottomBar from "@/components/feature/MobileBottomBar";

export default function Hochzeit() {
  return (
    <>
      <Navbar />

      {/* Hero Section */}
      <section className="relative min-h-[500px] md:min-h-[600px] lg:min-h-[700px] flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src="https://storage.helloreaddy.io/project_files/ccd3f37f-a1a3-49ba-8460-6107752c615a/73470345-9430-42ce-937c-33a3f8d8b5d2_compressed_Hochzeit-Florisitk.webp"
            alt="Hochzeitsfloristik – Brautstrauß mit Rosen und Eukalyptus in elegantem Ambiente"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
        </div>

        {/* Hero Content */}
        <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 text-center pt-20">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white mb-4 md:mb-6 max-w-4xl mx-auto leading-tight drop-shadow-lg">
            Hochzeitsfloristik
          </h1>
          <p className="text-white/90 text-base md:text-lg lg:text-xl max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed drop-shadow-md">
            Von der ersten Idee bis zum großen Tag entwickeln wir eine Hochzeitsfloristik, die Ihre Persönlichkeit und die Atmosphäre Ihrer Feier widerspiegelt.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center px-8 py-3.5 bg-background-50 text-foreground-950 rounded-md text-sm font-medium hover:bg-white transition-colors whitespace-nowrap shadow-lg"
            >
              Beratung zur Hochzeit anfragen
            </Link>
            <a
              href="https://www.fleurop.de/partnerfloristen/fleurop-filialen/26789-leer/florale-manufaktur-blumen-stoehr-gmbh-heisfelder-str-105"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-8 py-3.5 border-2 border-white/80 text-white rounded-md text-sm font-medium hover:bg-white/10 transition-colors whitespace-nowrap"
            >
              <i className="ri-send-plane-line w-4 h-4 flex items-center justify-center mr-2"></i>
              Blumen online über Fleurop versenden
            </a>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <main>
        <div className="max-w-4xl mx-auto px-4 md:px-6 py-16 md:py-24">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-6">
            Unser Angebot für Ihren besonderen Tag
          </h2>
          <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-10">
            Wir begleiten Sie bei der Planung Ihrer Hochzeitsfloristik – von der Farbkonzeption über die Auswahl der Blumen bis zur finalen Gestaltung vor Ort. Jedes Detail wird mit Ihnen abgestimmt, damit Ihre Hochzeit genau so wird, wie Sie sie sich vorstellen.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
            {[
              { icon: "ri-flower-line", title: "Individuelle Brautsträuße", desc: "Handgebunden und auf Ihren Stil abgestimmt" },
              { icon: "ri-user-heart-line", title: "Anstecker für Brautpaar und Gäste", desc: "Passend zum Brautstrauß und Farbkonzept" },
              { icon: "ri-table-line", title: "Tischdekoration und Tafelaufsätze", desc: "Elegante Tafelgestaltung für festliche Momente" },
              { icon: "ri-building-line", title: "Raum- und Kirchenschmuck", desc: "Florale Raumgestaltung für Kirche und Location" },
              { icon: "ri-palette-line", title: "Florale Begleitung des Hochzeitskonzepts", desc: "Vom Konzept bis zur Umsetzung an Ihrem Tag" },
              { icon: "ri-chat-heart-line", title: "Persönliche Beratung und Farbkonzeption", desc: "Gemeinsam finden wir Ihren perfekten Stil" },
            ].map((item) => (
              <div
                key={item.title}
                className="flex items-start gap-4 p-4 md:p-5 rounded-lg bg-background-100 border border-background-200/70"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 shrink-0">
                  <i className={`${item.icon} w-5 h-5 flex items-center justify-center text-primary-600`}></i>
                </div>
                <div>
                  <h3 className="font-medium text-foreground-950 text-sm md:text-base mb-1">
                    {item.title}
                  </h3>
                  <p className="text-foreground-600 text-sm">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center px-8 py-3.5 bg-primary-500 text-background-50 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              Jetzt Hochzeitsberatung vereinbaren
            </Link>
          </div>
        </div>
      </main>

      <Footer />
      <MobileBottomBar />
    </>
  );
}